import { addMinutes } from 'date-fns'

import { CALENDAR_GRID_MINUTES_PER_ROW } from '../../../CalendarGrid.constants'
import { getCalendarGridCellStart } from '../../CalendarGridWeek.utils'

function getCalendarGridWeekSelectionHours({ anchorHour, hour }) {
  return {
    fromHour: Math.min(anchorHour, hour),
    toHour: Math.max(anchorHour, hour),
  }
}

function getIsCalendarGridWeekHourInSelection({ hour, selection }) {
  const { fromHour, toHour } = getCalendarGridWeekSelectionHours(selection)

  const isAtOrAfterFromHour = hour >= fromHour
  const isAtOrBeforeToHour = hour <= toHour

  return isAtOrAfterFromHour && isAtOrBeforeToHour
}

export function getHasCalendarGridWeekSelectionRange(selection) {
  return selection?.anchorHour !== selection?.hour
}

export function getCalendarGridWeekSelectionRange({ selection, timezone }) {
  const { day } = selection

  const { fromHour, toHour } = getCalendarGridWeekSelectionHours(selection)

  return {
    end: addMinutes(
      getCalendarGridCellStart({ day, hour: toHour, timezone }),
      CALENDAR_GRID_MINUTES_PER_ROW
    ),
    start: getCalendarGridCellStart({ day, hour: fromHour, timezone }),
  }
}

export function getIsCalendarGridWeekSelectionDay({ day, selection }) {
  return selection?.day === day
}

export function getIsCalendarGridWeekCellSelected({ day, hour, selection }) {
  return (
    getIsCalendarGridWeekSelectionDay({ day, selection }) &&
    getIsCalendarGridWeekHourInSelection({ hour, selection })
  )
}
